import { Colors } from "@kamstrup/kfl";

const progressContainer = {
  position: "relative",
  height: "4px",
  width: "100%",
  backgroundColor: Colors.GREY_12,
  borderRadius: "4px",
  overflow: "hidden",
  marginTop: "24px"
};

const progressBar = {
  height: "100%",
  transition: "width 0.3s ease"
};

const strengthInfo = {
  display: "flex",
  alignItems: "center",
  marginTop: "8px"
};

const strengthText = {
  marginRight: "8px"
};

const infoIcon = {
  height: "1rem",
  width: "1rem",
  marginLeft: "0.25rem",
  color: Colors.GREY_75,
  position: "relative",
  top: "0.1rem"
};

export { progressContainer, progressBar, strengthInfo, strengthText, infoIcon };
